// EchoFloat media-plane control messages: bodies of UDP packets with type=Control.
// Always transport-AEAD sealed (docs/protocol.md §2). Source of truth: §1, §5, §6.

// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file echo/media/v1/media.proto (package echo.media.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file echo/media/v1/media.proto.
 */
export const file_echo_media_v1_media: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message echo.media.v1.ControlMessage
 */
export type ControlMessage = Message<"echo.media.v1.ControlMessage"> & {
  /**
   * @generated from oneof echo.media.v1.ControlMessage.msg
   */
  msg: {
    /**
     * @generated from field: echo.media.v1.ClientHello client_hello = 1;
     */
    value: ClientHello;
    case: "clientHello";
  } | {
    /**
     * @generated from field: echo.media.v1.HelloAck hello_ack = 2;
     */
    value: HelloAck;
    case: "helloAck";
  } | {
    /**
     * @generated from field: echo.media.v1.Resume resume = 3;
     */
    value: Resume;
    case: "resume";
  } | {
    /**
     * @generated from field: echo.media.v1.ResumeAck resume_ack = 4;
     */
    value: ResumeAck;
    case: "resumeAck";
  } | {
    /**
     * @generated from field: echo.media.v1.ReceiverReport receiver_report = 5;
     */
    value: ReceiverReport;
    case: "receiverReport";
  } | {
    /**
     * @generated from field: echo.media.v1.SenderFeedback sender_feedback = 6;
     */
    value: SenderFeedback;
    case: "senderFeedback";
  } | {
    /**
     * @generated from field: echo.media.v1.SpeakerSet speaker_set = 7;
     */
    value: SpeakerSet;
    case: "speakerSet";
  } | {
    /**
     * @generated from field: echo.media.v1.Goodbye goodbye = 8;
     */
    value: Goodbye;
    case: "goodbye";
  } | {
    /**
     * @generated from field: echo.media.v1.SubscribeStream subscribe_stream = 9;
     */
    value: SubscribeStream;
    case: "subscribeStream";
  } | {
    /**
     * @generated from field: echo.media.v1.UnsubscribeStream unsubscribe_stream = 10;
     */
    value: UnsubscribeStream;
    case: "unsubscribeStream";
  } | {
    /**
     * @generated from field: echo.media.v1.RequestKeyframe request_keyframe = 11;
     */
    value: RequestKeyframe;
    case: "requestKeyframe";
  } | {
    /**
     * @generated from field: echo.media.v1.StreamAudience stream_audience = 12;
     */
    value: StreamAudience;
    case: "streamAudience";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.media.v1.ControlMessage.
 * Use `create(ControlMessageSchema)` to create a new message.
 */
export const ControlMessageSchema: GenMessage<ControlMessage> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 0);

/**
 * C -> SFU, retried every 250ms up to 5s. Sealed with key_c2s; SFU identifies
 * the pending session by header.sender_id (few candidates -> AEAD-verify each).
 *
 * @generated from message echo.media.v1.ClientHello
 */
export type ClientHello = Message<"echo.media.v1.ClientHello"> & {
  /**
   * 32B from JoinAccept
   *
   * @generated from field: bytes handshake_token = 1;
   */
  handshakeToken: Uint8Array;

  /**
   * anti-amplification: response must not exceed request size before auth,
   * so the client pads the hello (>= 96 zero bytes)
   *
   * @generated from field: bytes padding = 2;
   */
  padding: Uint8Array;

  /**
   * What this client understands, as bits (echo_wire::media_caps). Absent on
   * an older client, which prost reads as 0. The relay ANDs this across the
   * subscribers of a stream and reports it back to the streamer in
   * SenderFeedback.subscriber_caps, so nothing goes on the wire that one of
   * the viewers cannot read (screenshare-plan.md D265).
   *
   * @generated from field: uint64 caps = 3;
   */
  caps: bigint;
};

/**
 * Describes the message echo.media.v1.ClientHello.
 * Use `create(ClientHelloSchema)` to create a new message.
 */
export const ClientHelloSchema: GenMessage<ClientHello> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 1);

/**
 * SFU -> C. src of the UDP packet = client's external addr (IP discovery).
 *
 * @generated from message echo.media.v1.HelloAck
 */
export type HelloAck = Message<"echo.media.v1.HelloAck"> & {
  /**
   * "ip:port" as seen by the SFU
   *
   * @generated from field: string external_addr = 1;
   */
  externalAddr: string;

  /**
   * 32B, lives for the whole SFU session
   *
   * @generated from field: bytes resume_secret = 2;
   */
  resumeSecret: Uint8Array;

  /**
   * What this relay understands, as bits (echo_wire::media_caps). Absent on
   * an older relay, which prost reads as 0 — a client sends nothing that
   * needs a bit the relay did not claim. Bit 0: the video header's `parity`
   * flag is carried through re-sealing (screenshare-plan.md D261).
   *
   * @generated from field: uint64 caps = 3;
   */
  caps: bigint;
};

/**
 * Describes the message echo.media.v1.HelloAck.
 * Use `create(HelloAckSchema)` to create a new message.
 */
export const HelloAckSchema: GenMessage<HelloAck> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 2);

/**
 * C -> SFU from a new src addr after network change; silent resume, no GW.
 *
 * @generated from message echo.media.v1.Resume
 */
export type Resume = Message<"echo.media.v1.Resume"> & {
  /**
   * @generated from field: bytes resume_secret = 1;
   */
  resumeSecret: Uint8Array;
};

/**
 * Describes the message echo.media.v1.Resume.
 * Use `create(ResumeSchema)` to create a new message.
 */
export const ResumeSchema: GenMessage<Resume> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 3);

/**
 * @generated from message echo.media.v1.ResumeAck
 */
export type ResumeAck = Message<"echo.media.v1.ResumeAck"> & {
  /**
   * @generated from field: string external_addr = 1;
   */
  externalAddr: string;
};

/**
 * Describes the message echo.media.v1.ResumeAck.
 * Use `create(ResumeAckSchema)` to create a new message.
 */
export const ResumeAckSchema: GenMessage<ResumeAck> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 4);

/**
 * C -> SFU every 1s: reception quality per forwarded stream (docs/protocol.md §5).
 *
 * @generated from message echo.media.v1.ReceiverReportEntry
 */
export type ReceiverReportEntry = Message<"echo.media.v1.ReceiverReportEntry"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * 0..255, like RTCP
   *
   * @generated from field: uint32 fraction_lost = 2;
   */
  fractionLost: number;

  /**
   * @generated from field: uint32 jitter_ms = 3;
   */
  jitterMs: number;

  /**
   * extended (wrap-corrected) highest seq seen
   *
   * @generated from field: uint32 ext_highest_seq = 4;
   */
  extHighestSeq: number;

  /**
   * Which of that sender's streams this is about (screenshare-plan.md D76):
   * 0 = Opus/voice, 1 = H.264/video, 2 = Opus/application audio. Absent means
   * 0, so an older client's reports still say "voice" and nothing has to guess.
   *
   * Without it the whole point of D76 is unreachable: a stream has its own seq
   * and its own losses, and one report per sender would fold a screencast's
   * packet loss into the voice adaptation state machine — exactly the failure
   * the split was made to avoid.
   *
   * @generated from field: uint32 payload_type = 5;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.ReceiverReportEntry.
 * Use `create(ReceiverReportEntrySchema)` to create a new message.
 */
export const ReceiverReportEntrySchema: GenMessage<ReceiverReportEntry> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 5);

/**
 * @generated from message echo.media.v1.ReceiverReport
 */
export type ReceiverReport = Message<"echo.media.v1.ReceiverReport"> & {
  /**
   * @generated from field: repeated echo.media.v1.ReceiverReportEntry entries = 1;
   */
  entries: ReceiverReportEntry[];
};

/**
 * Describes the message echo.media.v1.ReceiverReport.
 * Use `create(ReceiverReportSchema)` to create a new message.
 */
export const ReceiverReportSchema: GenMessage<ReceiverReport> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 6);

/**
 * SFU -> sender every 1s: aggregated view of one of the sender's own streams,
 * drives the good/degraded/bad adaptation state machine (one instance of it per
 * stream — the voice ladder and the video ladder in §5 are different tables).
 *
 * @generated from message echo.media.v1.SenderFeedback
 */
export type SenderFeedback = Message<"echo.media.v1.SenderFeedback"> & {
  /**
   * 0..255, worst across receivers
   *
   * @generated from field: uint32 fraction_lost = 1;
   */
  fractionLost: number;

  /**
   * max across receivers
   *
   * @generated from field: uint32 jitter_ms = 2;
   */
  jitterMs: number;

  /**
   * from ping/pong
   *
   * @generated from field: uint32 rtt_ms = 3;
   */
  rttMs: number;

  /**
   * as in ReceiverReportEntry; absent = 0 = voice
   *
   * @generated from field: uint32 payload_type = 4;
   */
  payloadType: number;

  /**
   * Bitwise AND of ClientHello.caps over every current subscriber of this
   * stream, 0 when nobody is subscribed (echo_wire::media_caps). A bit here
   * means every receiver can read what it enables; the sender may then use
   * it. Absent on an older relay, which prost reads as 0 — so a client that
   * cannot hear about its viewers sends them the plain format, which is the
   * safe end of the trade (screenshare-plan.md D265).
   *
   * @generated from field: uint64 subscriber_caps = 5;
   */
  subscriberCaps: bigint;
};

/**
 * Describes the message echo.media.v1.SenderFeedback.
 * Use `create(SenderFeedbackSchema)` to create a new message.
 */
export const SenderFeedbackSchema: GenMessage<SenderFeedback> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 7);

/**
 * SFU -> all clients on top-3 set change (docs/protocol.md §6).
 *
 * @generated from message echo.media.v1.SpeakerSet
 */
export type SpeakerSet = Message<"echo.media.v1.SpeakerSet"> & {
  /**
   * @generated from field: repeated uint32 sender_ids = 1;
   */
  senderIds: number[];
};

/**
 * Describes the message echo.media.v1.SpeakerSet.
 * Use `create(SpeakerSetSchema)` to create a new message.
 */
export const SpeakerSetSchema: GenMessage<SpeakerSet> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 8);

/**
 * either side: graceful leave
 *
 * @generated from message echo.media.v1.Goodbye
 */
export type Goodbye = Message<"echo.media.v1.Goodbye"> & {
};

/**
 * Describes the message echo.media.v1.Goodbye.
 * Use `create(GoodbyeSchema)` to create a new message.
 */
export const GoodbyeSchema: GenMessage<Goodbye> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 9);

/**
 * C -> SFU: start forwarding me this stream.
 *
 * @generated from message echo.media.v1.SubscribeStream
 */
export type SubscribeStream = Message<"echo.media.v1.SubscribeStream"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * 1 = the screen share's video, 2 = application audio, 3 = the camera
   * (camera-plan.md D685).
   *
   * @generated from field: uint32 payload_type = 2;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.SubscribeStream.
 * Use `create(SubscribeStreamSchema)` to create a new message.
 */
export const SubscribeStreamSchema: GenMessage<SubscribeStream> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 10);

/**
 * C -> SFU: stop. Sent on leaving the stream screen (D106) — an open
 * subscription nobody is looking at costs the viewer 2 Mbit/s of downlink and
 * the SFU the same in egress.
 *
 * @generated from message echo.media.v1.UnsubscribeStream
 */
export type UnsubscribeStream = Message<"echo.media.v1.UnsubscribeStream"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * @generated from field: uint32 payload_type = 2;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.UnsubscribeStream.
 * Use `create(UnsubscribeStreamSchema)` to create a new message.
 */
export const UnsubscribeStreamSchema: GenMessage<UnsubscribeStream> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 11);

/**
 * C -> SFU: I could not reassemble a frame, send me a reference one.
 *
 * The SFU throttles these to one per KEYFRAME_MIN_INTERVAL_MS per stream — not
 * per requester — and forwards a single one to the streamer (D85). Ten viewers
 * joining at once must not order ten I-frames back to back.
 *
 * @generated from message echo.media.v1.RequestKeyframe
 */
export type RequestKeyframe = Message<"echo.media.v1.RequestKeyframe"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * Which of that sender's video tracks (camera-plan.md D686): 1 = the screen
   * share, 3 = the camera. Absent (0) means 1 — the one video track there was —
   * so a request that names no track asks for the screen's picture, in both
   * directions.
   *
   * @generated from field: uint32 payload_type = 2;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.RequestKeyframe.
 * Use `create(RequestKeyframeSchema)` to create a new message.
 */
export const RequestKeyframeSchema: GenMessage<RequestKeyframe> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 12);

/**
 * SFU -> every bound client in the room: who each screen share is being
 * forwarded to (screenshare-plan.md D336). The relay is the one party that
 * knows — a subscription is its forwarding decision (D87) — so the count on the
 * stream screen is its word, not the clients' own accounts of themselves, and
 * an old build or a browser that subscribed is counted like anybody else.
 *
 * The whole room at once, never a delta: sent on a change — at once, but no
 * more often than once per 250 ms per room, so a member toggling a
 * subscription buys the room one snapshot per interval and not one per
 * datagram (D587) — then once a second while anybody is watching, and for a
 * few seconds more after the last one stops. The media plane is UDP, and a
 * snapshot that replaces everything is its own retransmission — a lost one is
 * corrected by the next. A streamer nobody is watching is simply absent.
 *
 * Claimed by the relay with media_caps::STREAM_AUDIENCE in HelloAck.caps, so a
 * streamer can tell "nobody is watching" from "this relay does not say". An
 * older client decodes the unknown arm as an empty ControlMessage and drops it.
 *
 * @generated from message echo.media.v1.StreamAudience
 */
export type StreamAudience = Message<"echo.media.v1.StreamAudience"> & {
  /**
   * @generated from field: repeated echo.media.v1.StreamAudienceEntry streams = 1;
   */
  streams: StreamAudienceEntry[];
};

/**
 * Describes the message echo.media.v1.StreamAudience.
 * Use `create(StreamAudienceSchema)` to create a new message.
 */
export const StreamAudienceSchema: GenMessage<StreamAudience> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 13);

/**
 * @generated from message echo.media.v1.StreamAudienceEntry
 */
export type StreamAudienceEntry = Message<"echo.media.v1.StreamAudienceEntry"> & {
  /**
   * the streamer
   *
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * bound sessions subscribed to its video, ascending
   *
   * @generated from field: repeated uint32 viewers = 2;
   */
  viewers: number[];
};

/**
 * Describes the message echo.media.v1.StreamAudienceEntry.
 * Use `create(StreamAudienceEntrySchema)` to create a new message.
 */
export const StreamAudienceEntrySchema: GenMessage<StreamAudienceEntry> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 14);

